import { memo } from "react";

export const ReturnTogetherItemReturnedSeparatelyDetails = memo(
  function ReturnTogetherItemReturnedSeparatelyDetails() {
    return null;
  },
);
